import { render, staticRenderFns } from "./other.vue?vue&type=template&id=1aa636ac&scoped=true&"
import script from "./other.vue?vue&type=script&lang=js&"
export * from "./other.vue?vue&type=script&lang=js&"
import style0 from "./other.vue?vue&type=style&index=0&id=1aa636ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa636ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aa636ac')) {
      api.createRecord('1aa636ac', component.options)
    } else {
      api.reload('1aa636ac', component.options)
    }
    module.hot.accept("./other.vue?vue&type=template&id=1aa636ac&scoped=true&", function () {
      api.rerender('1aa636ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/components/other.vue"
export default component.exports